import logger, { enableLog, disableLog } from '@/logger'

const plugin =
  (store) => {
    store.subscribe(() => {
      if (!store.getters['featureToggles/canUseLogFile']) {
        disableLog()
      } else {
        enableLog()
      }
    })

    const actionLog = logger.extend('vuex:action')

    // Set of vuex actions to ignore in logging
    const IGNORED_ACTIONS = new Set([
      'systemConnection/setEmqxConnection',
      'systemConnection/setSocketConnection',
      'websocket/newMessage',
    ])

    // Log actions
    store.subscribeAction({
      after: (action) => {
        // Skip logging for ignored actions
        if (IGNORED_ACTIONS.has(action.type)) {
          return
        }
        actionLog(`${action.type}`, action.payload)
      },
    })
  }

export default {
  plugin,
}
